import { DialogTag } from '@pixelgenau/ngx-dialog';

export interface VehicleGalleryOverlayDialogData {
    images: string[];
    activeIndex: number;
}

export const VehicleGalleryOverlayDialogTag = new DialogTag<VehicleGalleryOverlayDialogData, boolean>(
    'vehicle-gallery-overlay-dialog',
    async () => {
        const { M030C160VehicleGalleryOverlayComponent } = await import(
            './m030-c160-vehicle-gallery-overlay.component'
        );
        return M030C160VehicleGalleryOverlayComponent;
    },
);
